import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Products from './components/Products';
import Reviews from './components/Reviews';
import WhyJaws from './components/WhyJaws';
import Education from './components/Education';
import Lifestyle from './components/Lifestyle';
import Footer from '../../components/feature/Footer';
import Navbar from '../../components/feature/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Products />
      <Reviews />
      <WhyJaws />
      <Education />
      <Lifestyle />
      <Footer />
    </div>
  );
}
